const GET_GCP_CLOUD_RUN = "GET_GCP_CLOUD_RUN";
const GET_GCP_CLOUD_RUN_SUCCESS = "GET_GCP_CLOUD_RUN_SUCCESS";
const GET_GCP_CLOUD_RUN_ERROR = "GET_GCP_CLOUD_RUN_ERROR";

export {
  GET_GCP_CLOUD_RUN,
  GET_GCP_CLOUD_RUN_SUCCESS,
  GET_GCP_CLOUD_RUN_ERROR,
};
